import React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './DatePicker.css';

export type WxbDatePickerProps = React.ComponentProps<typeof AntdDatePicker> & { label?: string; error?: string; };

export const WxbDatePicker: React.FC<WxbDatePickerProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下面板就近渲染到触发器内;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdDatePicker
        {...(props as any)}
        id={controlId}
        className={`wxb-datepicker ${error ? 'wxb-dp-error' : ''} ${className}`}
        popupClassName="wxb-datepicker-popup"
        getPopupContainer={getPopupContainer}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
